<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--Descripción-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción"
          hint="Digite Información"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-text-field>
      </v-col>

      <!--Sigla-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.Sigla"
          label="Sigla"
          hint="Digite Información"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-text-field>
      </v-col>

      <!-- Tipo de Proceso -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TipoProceso"
          :items="ArrayTipoProceso"
          :item-title="
            (ArrayTipoProceso) =>
              ArrayTipoProceso.Valor + '-' + ArrayTipoProceso.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de Proceso:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Enlace -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Enlace"
          :items="ArrayEnlace"
          :item-title="
            (ArrayEnlace) => ArrayEnlace.Valor + '-' + ArrayEnlace.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Enlace:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Evaluacion -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Evaluacion"
          :items="ArrayEvaluacion"
          :item-title="
            (ArrayEvaluacion) =>
              ArrayEvaluacion.Valor + '-' + ArrayEvaluacion.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Evaluación:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Estado -->
      <v-col cols="6" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Estado"
          :items="ArrayEstado"
          :item-title="
            (ArrayEstado) => ArrayEstado.Valor + '-' + ArrayEstado.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Estado:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- ID Calendario Atención: -->
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="editedItem.CalendarioId"
          :items="ArrayCalendar"
          :item-title="
            (ArrayCalendar) =>
              ArrayCalendar.CalendarioId + '-' + ArrayCalendar.Descripcion
          "
          item-value="CalendarioId"
          color="primary"
          label="ID Calendario:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Horas Esperadas -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.HorasEsperadas"
          label="Horas Esperadas:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Minutos Esperadas -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.MinutosEsperados"
          label="Minutos Esperadas:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Horas Esperadas Calendario -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.HorasEsperadasCalendario"
          label="Horas Esperadas Calendario:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Minutos Esperadas Calendario -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.MinutosEsperadosCalendario"
          label="Minutos Esperadas Calendario:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo de Permiso -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TipoPermiso"
          :items="ArrayTipoPermiso"
          :item-title="
            (ArrayTipoPermiso) =>
              ArrayTipoPermiso.Valor + '-' + ArrayTipoPermiso.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de Permiso:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Proceso Asignado -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.ProcesoAsignado"
          :items="ArrayProcesos"
          :item-title="
            (ArrayProcesos) =>
              ArrayProcesos.ProcesoId + '-' + ArrayProcesos.Descripcion
          "
          item-value="ProcesoId"
          color="primary"
          label="Proceso Asignado:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Reasignación -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Reasignacion"
          :items="ArrayReAsignacion"
          :item-title="
            (ArrayReAsignacion) =>
              ArrayReAsignacion.Valor + '-' + ArrayReAsignacion.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Reasignación:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  postProcesos,
  putProcesos,
  getAllProcess,
} from "@/views/TCI/ProcesosP/Procesos/ProcesosService";
export default {
  name: "procesos-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        ProcesoId: 0,
        Descripcion: null,
        Sigla: null,
        TipoProceso: null,
        Enlace: null,
        AutorizacionRequerida: null,
        Estado: null,
        Evaluacion: null,
        CalendarioId: null,
        HorasEsperadas: null,
        MinutosEsperados: null,
        MinutosEsperadosCalendario: null,
        HorasEsperadasCalendario: null,
        PaginaPersonalizada: null,
        TipoPermiso: null,
        ProcesoAsignado: null,
        Reasignacion: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        ProcesoId: 0,
        Descripcion: null,
        Sigla: null,
        TipoProceso: null,
        Enlace: null,
        AutorizacionRequerida: null,
        Estado: null,
        Evaluacion: null,
        CalendarioId: null,
        HorasEsperadas: null,
        MinutosEsperados: null,
        MinutosEsperadosCalendario: null,
        HorasEsperadasCalendario: null,
        PaginaPersonalizada: null,
        TipoPermiso: null,
        ProcesoAsignado: null,
        Reasignacion: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayProcesos: [],
      ArrayEstado: [],
      ArrayTipoProceso: [],
      ArrayEnlace: [],
      ArrayEvaluacion: [],
      ArrayReAsignacion: [],
      ArrayTipoPermiso: [],
      ArrayCalendar: [],
    };
  },
  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      console.log(this.editedItem);
      if (
        this.editedItem.Descripcion == "" ||
        this.editedItem.Descripcion == null ||
        this.editedItem.Sigla == "" ||
        this.editedItem.Sigla == null ||
        this.editedItem.Enlace == "" ||
        this.editedItem.Enlace == null ||
        this.editedItem.Estado == "" ||
        this.editedItem.Estado == null ||
        this.editedItem.Evaluacion == "" ||
        this.editedItem.Evaluacion == null ||
        this.editedItem.CalendarioId == "" ||
        this.editedItem.CalendarioId == null ||
        this.editedItem.TipoPermiso == "" ||
        this.editedItem.TipoPermiso == null
      ) {
        validate = true;
      }

      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postProcesos(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putProcesos(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Procesos
    async getProcesos() {
      this.ArrayProcesos = [];
      const result = await getAllProcess();
      this.ArrayProcesos = result;
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    // Cargue Combos
    CargueCombos() {
      this.getProcesos();

      var Tables = this.$store.getters.MTablaSeleccion;
      this.ArrayEstado = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 71,
      );

      this.ArrayTipoProceso = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 69,
      );

      this.ArrayEnlace = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 70,
      );

      this.ArrayTipoPermiso = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 72,
      );

      this.ArrayEvaluacion = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 73,
      );

      this.ArrayReAsignacion = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 74,
      );

      var Calendario = this.$store.getters.MCalendario;
      this.ArrayCalendar = Calendario.filter((item) => item.Calendario_ID != 0);
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
